import { Menu, OpenInNew } from '@mui/icons-material';
import {
	Box,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText
} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { DARK_THEME } from '../../../../Redux/Types/themeTypes';
import { currentDomain } from '../../../../utils/domainBasedInfo/currentDomain';
import docsLogo from '../../../../assets/images/docsLogo.svg';

function CustomListItemButton({
	onClick,
	iconSrc,
	altText,
	text,
	showOpenInNew,
	currentTheme
}) {
	return (
		<ListItemButton onClick={onClick}>
			<ListItemIcon
				className={`sidebar-navItem ${
					currentTheme === DARK_THEME ? 'invert' : ''
				}`}
			>
				<img
					src={iconSrc}
					alt={altText}
					style={{ maxHeight: '25px', objectFit: 'contain' }}
					className={`nav-img ${
						currentTheme === DARK_THEME ? 'nav-canvas-img' : ''
					}`}
				/>
			</ListItemIcon>
			<ListItemText primary={text} />
			{showOpenInNew && (
				<ListItemIcon>
					<OpenInNew color="inherit" fontSize="inherit" />
				</ListItemIcon>
			)}
		</ListItemButton>
	);
}

function NavigationDrawer({ drawerState, toggleDrawer, handleNavigation }) {
	const { currentTheme } = useSelector((state) => state.themeReducer);
	return (
		<>
			<Drawer anchor="left" open={drawerState} onClose={toggleDrawer}>
				<Box
					sx={{ width: 'min(300px, 80svw)' }}
					role="presentation"
					onClick={toggleDrawer}
				>
					<List>
						{/* Main Navigation */}
						{currentDomain.header.navigation.map((navItem) => (
							<ListItem key={navItem.name}>
								<CustomListItemButton
									onClick={() => handleNavigation(navItem)}
									iconSrc={navItem.icon}
									altText={navItem.text}
									text={navItem.name}
									currentTheme={currentTheme}
								/>
							</ListItem>
						))}

						<Divider />

						{/* Documentation Link */}
						<ListItem title="Open qBraid docs in new tab">
							<CustomListItemButton
								onClick={() =>
									window.open(
										'https://docs.qbraid.com/lab/user-guide/overview',
										'_blank'
									)
								}
								iconSrc={docsLogo}
								altText="documentation"
								text="qBraid Docs"
								showOpenInNew
								currentTheme={currentTheme}
							/>
						</ListItem>

						<Divider />

						{/* Extra Navigation */}
						{currentDomain.header.extraNavigation.map((navItem) => (
							<ListItem key={navItem.name}>
								<CustomListItemButton
									onClick={() => window.open(navItem.link, '_blank')}
									iconSrc={
										currentTheme === DARK_THEME
											? navItem.icon_dark
											: navItem.icon
									}
									altText={navItem.name}
									text={navItem.name}
									showOpenInNew
									currentTheme={currentTheme}
								/>
							</ListItem>
						))}
					</List>
				</Box>
			</Drawer>
			<IconButton
				onClick={toggleDrawer}
				aria-label="navigation menu"
				sx={{ display: { xs: 'inline-flex', md: 'none' } }}
			>
				<Menu />
			</IconButton>
		</>
	);
}

export default NavigationDrawer;
